import React from 'react';
import Navbar from '../components/Navbar';
import HealthcareHero from '../components/healthcare/HealthcareHero';
import HealthcareProblem from '../components/healthcare/HealthcareProblem';
import WhyTraainHealthcare from '../components/healthcare/WhyTraainHealthcare';
import TrainingIntelligenceHealthcare from '../components/healthcare/TrainingIntelligenceHealthcare';
import RolePlayIntelligenceHealthcare from '../components/healthcare/RolePlayIntelligenceHealthcare';
import ExchangeHealthcare from '../components/healthcare/ExchangeHealthcare';
import HealthcareKPIs from '../components/healthcare/HealthcareKPIs';
import HealthcareCTA from '../components/healthcare/HealthcareCTA';
import Footer from '../components/Footer';

const HealthcarePage = () => {
  return (
    <div className="min-h-screen bg-gray-950 text-white">
      {/* Animated Background */}
      <div className="fixed inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-950 via-gray-900 to-cyan-950 animate-gradient" />
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-0 left-0 w-96 h-96 bg-blue-500 rounded-full filter blur-3xl animate-blob" />
          <div className="absolute top-0 right-0 w-96 h-96 bg-cyan-500 rounded-full filter blur-3xl animate-blob animation-delay-2000" />
          <div className="absolute bottom-0 left-1/2 w-96 h-96 bg-indigo-500 rounded-full filter blur-3xl animate-blob animation-delay-4000" />
        </div>
      </div>

      {/* Content */}
      <div className="relative z-10">
        <Navbar />
        <HealthcareHero />
        <HealthcareProblem />
        <WhyTraainHealthcare />
        <TrainingIntelligenceHealthcare />
        <RolePlayIntelligenceHealthcare />
        <ExchangeHealthcare />
        <HealthcareKPIs />
        <HealthcareCTA />
        <Footer />
      </div>
    </div>
  );
};

export default HealthcarePage;
